<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'approvalStatus'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="goBack()">
      {{ 'button.back' | transloco }}
    </htx-button>

    @let representativeDetails = representativeDetails$ | async;
    @let organisationDetails = organisationDetails$ | async;
    <div class="panel">
      <!-- Header Section -->
      <div class="header-section">
        <div class="header-title-section">
          <h1 class="header-title">{{ t('title') }}</h1>
          <p class="header-subtitle">{{ t('subtitle') }}</p>
        </div>
        @if (admissionState$ | async; as state) {
          <div class="header-status">
            <htx-badge
              [text]="getStatusTranslationKey(state) | transloco"
              [variant]="getStatusBadgeVariant(state)"
            ></htx-badge>
          </div>
        }
      </div>

      <!-- Status Description -->
      @if ((admissionState$ | async) === 'PENDING') {
        <div class="status-message status-pending">
          <span class="material-icons">hourglass_empty</span>
          <p>{{ t('pendingMessage') }}</p>
        </div>
      } @else if ((admissionState$ | async) === 'APPROVED') {
        <div class="status-message status-approved">
          <span class="material-icons">check_circle</span>
          <p>{{ t('approvedMessage') }}</p>
        </div>
      } @else if ((admissionState$ | async) === 'REJECTED') {
        <div class="status-message status-rejected">
          <span class="material-icons">cancel</span>
          <p>{{ t('rejectedMessage') }}</p>
        </div>
      }

      <!-- Organization Details -->
      <div class="details-grid">
        <htx-data-display
          [title]="t('details.representative')"
          [icon]="'person'"
          [data]="representativeDetails ?? []"
          [loading]="representativeDetails === null"
        ></htx-data-display>

        <htx-data-display
          [title]="t('details.organisation')"
          [icon]="'business'"
          [data]="organisationDetails ?? []"
          [loading]="organisationDetails === null"
        ></htx-data-display>
      </div>

      <!-- Registration Document -->
      <htx-data-container [title]="t('document.title')" [icon]="'description'">
        <div class="document-section">
          <p>{{ t('document.description') }}</p>
          <htx-button variant="secondary" icon="visibility" (click)="openDocument()">
            {{ t('document.view') }}
          </htx-button>
        </div>
      </htx-data-container>

      <!-- Messages/Communication -->
      <htx-data-container [title]="t('messages.title')" [icon]="'chat'">
        <p class="messages-description">{{ t('messages.description') }}</p>
        <app-comments
          [comments]="(commentsForBox$ | async) ?? []"
          [hasMore]="(hasMoreComments$ | async) ?? false"
          [placeholder]="t('messages.placeholder')"
          (commentAdded)="onCommentAdded($event)"
          (loadMore)="loadMoreComments()"
        ></app-comments>
      </htx-data-container>
    </div>
  </div>
</app-protected-content>
